module.exports = __webpack_public_path__ + "img/rotate-arrow-to-the-right.64ea226c.svg";